export const generateLogJobDownloadFilename = (
  logId: string,
  jobId: string
) => {
  return `${logId}-${jobId}.txt`;
};
